import React, { useState } from 'react';
import { styled } from '@mui/material';
import { MoreHoriz } from '@mui/icons-material';
import { Colors } from 'library';
import { RDropdownMenu, RDropdownMenuItem } from './RDropdownMenu';
import { RBaseButton } from './RBaseButton';

interface RMenuButtonProps {
    items: RDropdownMenuItem[];
    width?: number;
    variant?: 'default' | 'outlined';
    stopPropagation?: boolean;
}

export function RMenuButton({ items, width, variant = 'default', stopPropagation }: RMenuButtonProps) {
    const [open, setOpen] = useState(false);

    const closedItems = items.map((item) => ({
        ...item,
        onClick: () => {
            item.onClick?.();
            setOpen(false);
        },
    }));

    return (
        <RDropdownMenu
            open={open}
            onClose={() => setOpen(false)}
            items={closedItems}
            width={width}
            trigger={
                variant === 'outlined' ? (
                    <OutlinedButton
                        onClick={(e) => {
                            if (stopPropagation) { e.stopPropagation(); e.preventDefault(); }
                            setOpen(!open);
                        }}
                    >
                        <MoreHoriz sx={{ fontSize: 20 }} />
                    </OutlinedButton>
                ) : (
                    <DefaultButton
                        onClick={(e) => {
                            if (stopPropagation) { e.stopPropagation(); e.preventDefault(); }
                            setOpen(!open);
                        }}
                    >
                        <MoreHoriz sx={{ fontSize: 20, color: Colors.mediumGrey }} />
                    </DefaultButton>
                )
            }
        />
    );
}

const DefaultButton = styled(RBaseButton)({
    color: Colors.darkNavy,
    padding: 4,
    borderRadius: 4,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&:hover': { backgroundColor: Colors.fill },
});

const OutlinedButton = styled(RBaseButton)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 40,
    height: 40,
    borderRadius: '50%',
    border: `1px solid ${Colors.lightGrey}`,
    backgroundColor: Colors.white,
    color: Colors.darkNavy,
    '&:hover': { backgroundColor: Colors.faintGrey },
});
